var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkImg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.84,
    height: 176.881,
    viewBox: "0 0 120.84 176.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349",
    transform: "translate(34.639 41.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(0.629 16.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M49.512-54.4H8A4.4,4.4,0,0,1,3.6-58.793v-29.02A4.406,4.406,0,0,1,8-92.207h8.331a.747.747,0,0,1,.746.746.747.747,0,0,1-.746.746H8a2.823,2.823,0,0,0-2.828,2.828v28.945A2.822,2.822,0,0,0,8-56.119H49.512a2.822,2.822,0,0,0,2.828-2.823v-28.87a2.823,2.823,0,0,0-2.828-2.828h-8.48a.747.747,0,0,1-.746-.746.747.747,0,0,1,.746-.746h8.48A4.4,4.4,0,0,1,53.9-87.738v28.945A4.4,4.4,0,0,1,49.512-54.4Z",
    transform: "translate(-3.602 92.207)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(10.327 52.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M35.535-78.223H6.218a.9.9,0,0,1-.671-.368.855.855,0,0,1-.075-.746L7.7-84.919a.776.776,0,0,1,.969-.447.776.776,0,0,1,.447.969L7.336-79.858H34.417L32.632-84.4a.776.776,0,0,1,.447-.969.768.768,0,0,1,.964.447l2.237,5.582a.882.882,0,0,1-.075.746A.655.655,0,0,1,35.535-78.223Z",
    transform: "translate(-5.423 85.413)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(0 62.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M52.553-71.79H5.977A2.4,2.4,0,0,1,3.82-73.053a2.414,2.414,0,0,1,0-2.456l4.24-7.665a.783.783,0,0,1,.671-.373H49.8a.783.783,0,0,1,.671.373l4.24,7.665a2.413,2.413,0,0,1,0,2.456A2.4,2.4,0,0,1,52.553-71.79ZM9.173-82.055,5.157-74.762a1.046,1.046,0,0,0,0,.964.86.86,0,0,0,.82.447h46.5a.86.86,0,0,0,.82-.447,1.046,1.046,0,0,0,0-.964l-3.942-7.292Z",
    transform: "translate(-3.484 83.546)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(21.466 30.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M11.829-71.711a.274.274,0,0,1-.224-.075.744.744,0,0,1-.373-.3L7.663-76.772a.79.79,0,0,1-.149-.591L9.3-88.97a.771.771,0,0,1,.895-.671.768.768,0,0,1,.666.89L9.075-77.437,11.9-73.794l2.828-3.643L12.947-88.751a.764.764,0,0,1,.666-.89.771.771,0,0,1,.895.671l1.784,11.607a.79.79,0,0,1-.149.591l-3.569,4.687a.744.744,0,0,1-.373.3h-.075A.564.564,0,0,1,11.829-71.711Z",
    transform: "translate(-7.514 89.652)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(14.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(8.336 3.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(1.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M8.93-89.637a.747.747,0,0,1-.746-.746v-3.494a.747.747,0,0,1,.746-.746.747.747,0,0,1,.746.746v3.42A.767.767,0,0,1,8.93-89.637Z",
    transform: "translate(-8.184 94.623)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(0 1.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M12.028-92.811H8.609a.747.747,0,0,1-.746-.746.747.747,0,0,1,.746-.746h3.42a.747.747,0,0,1,.746.746C12.849-93.109,12.476-92.811,12.028-92.811Z",
    transform: "translate(-7.863 94.302)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M17.09-82.508A40.042,40.042,0,0,1,7.267-83.7l-.373-.075a.726.726,0,0,1-.6-.746v-6.7a4.136,4.136,0,0,1,4.1-4.1H23.785a4.131,4.131,0,0,1,4.091,4.1v6.7a.722.722,0,0,1-.591.746A39.606,39.606,0,0,1,17.09-82.508Zm-9.226-2.6a40.9,40.9,0,0,0,18.526,0v-6.1a2.506,2.506,0,0,0-2.53-2.53H10.394a2.506,2.506,0,0,0-2.53,2.53Z",
    transform: "translate(-6.298 95.308)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348",
    transform: "translate(5.54 13.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(9.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M17.146-77.5a9.672,9.672,0,0,1-9-6.323A33.549,33.549,0,0,1,6.285-92a.762.762,0,0,1,.74-.82.766.766,0,0,1,.82.746A30.9,30.9,0,0,0,9.63-84.341a8.043,8.043,0,0,0,7.59,5.359,8.043,8.043,0,0,0,7.59-5.359,32.567,32.567,0,0,0,1.784-7.59.766.766,0,0,1,.82-.74.764.764,0,0,1,.74.815A35.342,35.342,0,0,1,26.3-83.819,10.019,10.019,0,0,1,17.146-77.5Z",
    transform: "translate(-6.285 92.821)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(26.089 10.756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M23.069-70.828H10.195a.743.743,0,0,1-.74-.746.742.742,0,0,1,.74-.74H22.249l-.075-5.508a6.937,6.937,0,0,0-.89-3.574,6.93,6.93,0,0,0-1.641-1.934c-2.6-2.083-9.748-5.95-9.822-6.024a.764.764,0,0,1-.3-1.044.755.755,0,0,1,1.044-.3,96.38,96.38,0,0,1,10.046,6.179,8.678,8.678,0,0,1,2.008,2.381,9.982,9.982,0,0,1,1.119,4.315l.144,6.174a.673.673,0,0,1-.218.522A.892.892,0,0,1,23.069-70.828Z",
    transform: "translate(-9.422 90.802)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(0 10.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M18.144-70.889H5.27a.677.677,0,0,1-.522-.224.806.806,0,0,1-.224-.522l.149-6.174a8.267,8.267,0,0,1,1.119-4.315A6.938,6.938,0,0,1,7.8-84.5a96.371,96.371,0,0,1,10.046-6.179.747.747,0,0,1,1.039.3.757.757,0,0,1-.293,1.044c-.075.075-7.218,3.942-9.822,6.024a6.93,6.93,0,0,0-1.641,1.934,7.117,7.117,0,0,0-.89,3.574L6.09-72.45H18.144a.742.742,0,0,1,.74.74A.721.721,0,0,1,18.144-70.889Z",
    transform: "translate(-4.524 90.788)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M117.821-66.873V-32.1c0,40.706-23.368,60.383-41.468,75.58-7.479,6.3-14.041,11.8-17.4,17.636a1.712,1.712,0,0,1-.66.693,1.62,1.62,0,0,1-2.179-.6c-3.393-5.833-9.982-11.335-17.5-17.631C20.45,28.356-3.019,8.68-3.019-32.1V-66.873a1.61,1.61,0,0,1,1.582-1.614c38.7,0,57.288-33.329,57.549-33.787a1.687,1.687,0,0,1,.6-.591,1.593,1.593,0,0,1,2.168.591c.037.1,18.654,33.787,57.357,33.787A1.613,1.613,0,0,1,117.821-66.873ZM114.62-32.1V-65.323C81.232-66.085,62.509-90.806,57.5-98.449,52.49-90.806,33.735-66.085.177-65.323V-32.1c0,39.321,22.809,58.438,40.477,73.241C47.515,46.882,53.608,52.022,57.5,57.493c3.819-5.5,9.955-10.643,16.811-16.449C91.912,26.279,114.62,7.162,114.62-32.1Z",
    transform: "translate(3.019 103.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M19.819-71.264a1.616,1.616,0,0,1,1.614,1.614,1.61,1.61,0,0,1-1.614,1.582H11.547A1.61,1.61,0,0,1,9.933-69.65a1.616,1.616,0,0,1,1.614-1.614Z",
    transform: "translate(59.057 240.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M28.025-68.852a1.565,1.565,0,0,1-1.582,1.582H8.71a1.587,1.587,0,0,1-1.587-1.582A1.614,1.614,0,0,1,8.71-70.466H26.443A1.593,1.593,0,0,1,28.025-68.852Z",
    transform: "translate(46.9 244.151)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkImg6);
export default __webpack_public_path__ + "static/media/work-img6.6b0987b7fa8c9d5a2ff3c7ffb8ac919f.svg";
export { ForwardRef as ReactComponent };